import { Options, Vue } from "vue-class-component";

import List from "@/pages/platform/list/list.vue";

@Options({
  name: "platform",
  components: {
    "page-list": List,
  },
})
export default class Platform extends Vue {
  public isIndexOnly() {
    return /^[/]?platform[/]?$/.test(this.$router.currentRoute.value.path);
  }
}
